import IconCard, { CardDescription, CardValue } from "components/company/cards/IconCard";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import parseDateYmd from "lib/utils/parseDateYmd";
import numeral from "numeral";
import type { IAmericanCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";
import type { IBrazilianRealEstateFundTopLevelFragment } from "lib/fragments/__generated__/BrazilianRealEstateFundTopLevel.generated";
import { getYear } from "date-fns";
import PieChartIcon from "components/svg/PieChartIcon";
import { FormattedMessage, useIntl } from "react-intl";
import colors from "tailwindcss/colors";

interface IIndexParticipationCardProps {
  issuer:
    | IBrazilianCompanyIssuerTopLevelFragment
    | IBrazilianRealEstateFundTopLevelFragment
    | IAmericanCompanyIssuerTopLevelFragment;
}

export default function IndexParticipationCard({ issuer }: IIndexParticipationCardProps) {
  const intl = useIntl();

  const isAmericanIssuer = issuer.__typename === "AmericanCompanyIssuer";
  const isBrazilianIssuer = issuer.__typename === "BrazilianCompanyIssuer";
  const isBrazilianRealEstateFundIssuer = issuer.__typename === "BrazilianRealEstateFund";
  const year = getYear(new Date());

  if (isBrazilianIssuer && issuer.b3IndexParticipation && issuer.b3IndexParticipation.stockParticipationPercent !== 0) {
    return (
      <div>
        <IconCard primaryColor={colors.emerald[700]} secondaryColor={colors.emerald[50]} icon={<PieChartIcon />}>
          <CardValue>
            {numeral(issuer.b3IndexParticipation.stockParticipationPercent).format("0.00").replace(".", ",")}%
          </CardValue>
          <CardDescription>
            <FormattedMessage
              defaultMessage="Ibovespa • até {date}"
              id="85cSTr"
              values={{
                date: intl.formatDate(parseDateYmd(issuer.b3IndexParticipation.marketIndex.validUntil), {
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                }),
              }}
            />
          </CardDescription>
        </IconCard>
      </div>
    );
  }

  if (isAmericanIssuer && issuer.standardAndPoorsIndicator) {
    return (
      <div>
        <IconCard primaryColor={colors.emerald[700]} secondaryColor={colors.emerald[50]} icon={<PieChartIcon />}>
          <CardValue>S&P500 Participant</CardValue>
          <CardDescription>Index Composite • {year}</CardDescription>
        </IconCard>
      </div>
    );
  }

  if (isBrazilianRealEstateFundIssuer && issuer.ifixParticipation) {
    return (
      <div>
        <IconCard primaryColor={colors.emerald[700]} secondaryColor={colors.emerald[50]} icon={<PieChartIcon />}>
          <CardValue>{numeral(issuer.ifixParticipation.asPercentage).format("0.00").replace(".", ",")}%</CardValue>
          <CardDescription>IFIX • {year}</CardDescription>
        </IconCard>
      </div>
    );
  }

  return null;
}
